import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";

export class BlogDataModel extends Model {
   constructor(
        public author: string = "",
        public authorDescription: string = "",
        public tags: string[] = [],
        public banner: string = "",
        public profile: string = "",
        public contentUrl: string = "",
        public metaTitle: string = "",
        public metaDescription: string = "",
        public metaImageUrl: string = "",
    ) {
        super();
    }

    public static create(model: Partial<BlogDataModel>): BlogDataModel {
        return createModel<BlogDataModel>(BlogDataModel, {
            ...model
        });
    }
}
